import { useEffect, useState } from "react";
import Layout from "../../layout.tsx/app";
import { twMerge } from "tailwind-merge";
import { FormProvider, useForm } from "react-hook-form";
import { Editor } from "@tinymce/tinymce-react";
import { useGeneralSettingStore } from "./general-setting.store";
import { Spinner } from "flowbite-react";
import { Button } from "../../../components/buttons";
import { request } from "../../../api/config";
import { useAlert } from "../../../stores/alert";

type FormType = {
  name: string;
  value: string;
};

type FormError = {
  name: [] | null;
  vallue: [] | null;
};

const SettingGeneral = () => {
  const [page, setPage] = useState<string>("petunjuk-tes-online");
  const [loading, setLoading] = useState<boolean>(false);

  const { getSetting, setting, loadingSetting } = useGeneralSettingStore();
  const { setMessage } = useAlert();
  const forms = useForm<FormType>();

  const pages = [
    {
      label: "Petunjuk Test Online",
      name: "petunjuk-tes-online",
    },
    {
      label: "Petunjuk Test Offline",
      name: "petunjuk-tes-offline",
    },
  ];

  const onSubmit = forms.handleSubmit(async (data) => {
    try {
      setLoading(true);
      await request.post("/setting/general", {
        ...data,
        name: page,
      });
      getSetting({ name: page });
      setMessage("Berhasil menyimpan data", "success");
    } catch (error) {
      setMessage("Oops, gagal menyimpan data", "error");
    } finally {
      setLoading(false);
    }
  });

  useEffect(() => {
    getSetting({ name: page });
  }, [getSetting, page]);

  return (
    <>
      <Layout withPageTitle title="Pengaturan Umum">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-2 items-start">
          <div className="w-full bg-gray-50 text-base text-gray-700 ">
            {pages.map((item, key) => (
              <div
                key={key}
                className={twMerge(
                  "p-3 select-none cursor-pointer hover:font-semibold hover:bg-gray-100",
                  page === item.name && "font-semibold bg-gray-100"
                )}
                onClick={() => setPage(item.name)}
              >
                {item.label}
              </div>
            ))}
          </div>
          <div className="md:col-span-4">
            <FormProvider {...forms}>
              {loadingSetting ? (
                <>
                  <div className="w-full h-32 flex items-center justify-center">
                    <Spinner />
                  </div>
                </>
              ) : (
                <Editor
                  apiKey={process.env.REACT_APP_TINYMCE_API}
                  value={setting?.value ? JSON.parse(setting?.value) : ""}
                  init={{
                    height: 600,
                    menubar: false,
                    plugins: ["image"],
                    toolbar:
                      "undo redo | formatselect | bold italic | alignleft aligncenter alignright | bullist numlist outdent indent | image",
                    // images_upload_handler: handleImageUpload,
                    images_upload_handler: (blobInfo) => {
                      const base64str =
                        "data:" +
                        blobInfo.blob().type +
                        ";base64," +
                        blobInfo.base64();
                      return Promise.resolve(base64str);
                    },
                  }}
                  onEditorChange={(content, _) =>
                    forms.setValue("value", content)
                  }
                />
              )}
              <div className="flex items-center justify-end py-3">
                <Button disabled={loading} className="px-8" onClick={onSubmit}>
                  {loading ? <Spinner /> : "Simpan"}
                </Button>
              </div>
            </FormProvider>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default SettingGeneral;
